import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

type ImagePreviewTokens = {
  bg: string
  border: string
  emptyText: string
  focusRing: string
}

const tokens: Record<ColorScheme, ImagePreviewTokens> = {
  dark: {
    bg: 'bg.card',
    border: 'border.subtle',
    emptyText: 'text.tertiary',
    focusRing: 'interactive.focus-ring',
  },
  light: {
    bg: 'light.bg.card',
    border: 'light.border.subtle',
    emptyText: 'light.text.tertiary',
    focusRing: 'light.interactive.focus-ring',
  },
}

export const imagePreviewFrameStyles = (
  colorScheme: ColorScheme,
  isInteractive: boolean,
  height: string
): SystemStyleObject => ({
  alignItems: 'center',
  bg: tokens[colorScheme].bg,
  border: '1px solid',
  borderColor: tokens[colorScheme].border,
  borderRadius: '0',
  cursor: isInteractive ? 'pointer' : 'default',
  display: 'flex',
  h: height,
  justifyContent: 'center',
  overflow: 'hidden',
  p: 0,
  textAlign: 'left',
  w: 'full',
  _focusVisible: {
    outline: '2px solid',
    outlineColor: tokens[colorScheme].focusRing,
    outlineOffset: '2px',
  },
})

export const imagePreviewImageStyles = (
  objectFit: 'cover' | 'contain'
): SystemStyleObject => ({
  display: 'block',
  h: 'full',
  objectFit,
  w: 'full',
})

export const imagePreviewEmptyStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: tokens[colorScheme].emptyText,
  textStyle: 'caption',
})
